class UrlCalc {
  static getHash(targetPath_, withHashMark = true) {
    let hash = targetPath_.split(`#`)[1]
    let targetHash = withHashMark? `#` + hash: hash
    return targetHash
  }
}

export default UrlCalc
